import { IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import Language, { ILanguageDto } from "./Language"

export interface IGetTenantSettingsLanguagesDto {
    primaryLanguage: ILanguageDto
    maintainableLanguages: ILanguageDto[]
    links: IApiLink[]
}

export interface IUpdateTenantSettingsLanguagesDto {
    maintainableLanguages: string[]
}

export default class TenantSettingsLanguages {
    primaryLanguage: Language
    maintainableLanguages: Language[]

    linkUpdate?: IApiLink

    constructor(dto: IGetTenantSettingsLanguagesDto) {
        this.primaryLanguage = new Language(dto.primaryLanguage)
        this.maintainableLanguages = dto.maintainableLanguages.map(languageDto => new Language(languageDto))

        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsLanguage && lnk.rel === ApiLinkRel.update)
    }
}
